import client from './client';

// ============ 초대코드 ============

// 초대코드 생성
export const createInvitation = async (expiresDays = 7) => {
  const response = await client.post('/admin/invitations', {
    expires_days: expiresDays
  });
  return response.data;
};

// 초대코드 목록 조회
export const getInvitations = async () => {
  const response = await client.get('/admin/invitations');
  return response.data;
};

// 초대코드 삭제
export const deleteInvitation = async (code) => {
  const response = await client.delete(`/admin/invitations/${code}`);
  return response.data;
};

// ============ 사용자 관리 ============

// 사용자 목록 조회
export const getUsers = async () => {
  const response = await client.get('/admin/users');
  return response.data;
};

// 사용자 활성화/비활성화
export const toggleUserActive = async (userId) => {
  const response = await client.put(`/admin/users/${userId}/active`);
  return response.data;
};

// 사용자 삭제
export const deleteUser = async (userId) => {
  const response = await client.delete(`/admin/users/${userId}`);
  return response.data;
};
